import { CreditPromoter } from "./creditPromoter.model";
import { FinancialSettings } from "./financialSettings.model";
import { Product } from "./product.model";
import { SplitStatusEnum, SplitTimelineMap } from "./splitStatusEnum.model";
import { WhiteLabel } from "./whiteLabel.model";

export interface MasterUser {
  masterUserName: string;
  masterUserLastName: string;
  masterUserPhone: string;
  masterUserEmail: string;
  masterUserCpf: string;
}

export interface CorbanSplitSolicitation {
  id: string;
  status: SplitStatusEnum;
  rejectionReason?: string;
  rejectedBy?: string;
  createdAt: string;
  updatedAt: string;
  timeline: SplitTimelineMap;
}

export type Corban = {
  id?: number;
  document: string;
  legalName: string;
  businessName: string;
  automaticApproval: boolean;
  commission?: number | null;
  masterName: string;
  paymentSplit?: boolean;
  status?: "PENDING" | "APPROVED" | "REJECTED";
  sellerAuthorized?: string | null;
  sellerAuthorizedDocument?: string | null;

  financialSettingsId: string;
  FinancialSettings?: FinancialSettings;

  creditPromoterId: number | null;
  CreditPromoter?: CreditPromoter;

  WhiteLabel?: WhiteLabel | null;

  ProductCorbans?: ProductCorban[];
  products?: Product[];
  ConsigProductCorbans: any[]

  CreditTypeCorbans?: CorbanModalityPermission[]

  FinancialSettingsCorbansAndCreditPromoter?: FinancialSettingsCorbansAndCreditPromoter[]

  masterUser?: MasterUser | null;
  /** Master da promotora — responsável pela operação do split. */
  promoterMasterUser?: MasterUser | null;

  createdAt?: Date;

  timeline?: SplitTimelineMap;
  splitSolicitation?: CorbanSplitSolicitation;
};

export type ProductCorban = {
  productId: string;
  product?: Product;

  corbanId: number;
  corban?: Corban;

  createdAt?: Date;
};

export type ConsigProductCorbans = {
  productId: string;
  product?: Product;
}

export enum CorbanCreditModalityEnum {
  FGTS = 'FGTS',
  CONSIG_WORKER = 'CONSIG_WORKER'
}

export enum CorbanApiAccessEnum {
  FGTS = 'FGTS',
  CONSIGNADO = 'CONSIGNADO'
}

export interface CorbanModalityPermission {
  id: string;
  credit_type: CorbanCreditModalityEnum;
  api_enable: boolean;
  enable: boolean;
  corbanId: number;
}

export interface CreditTypeCorban {
  id: string;
  credit_type: CorbanCreditModalityEnum;
  api_enable: boolean;
  enable: boolean;
  createdAt: string;
  corbanId: number;
  userCanAccess: string;
  creditPromoterId: string;
}

export interface CorbanApiCredential {
  id: number;
  token: string | null;
  apiKey: string;
  webhook: string;
  productAccess: CorbanApiAccessEnum;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export type FinancialSettingsCorbansAndCreditPromoter = {
  id: string;
  corbanId: number;
  creditPromoterId: number | null;
  creditType: CorbanCreditModalityEnum;
  financialSettingsId: string;
  FinancialSettings: FinancialSettings;
};


